<template>
  <svg
    class="status-dot"
    :height="size"
    :width="size"
    :viewBox="`0 0 ${size} ${size}`"
  >
    <circle v-bind="center" :r="size / 2" :fill="backgroundColor" />
    <circle :r="size / 2 - strokeWidth" v-bind="center" :fill="fillColor" />
  </svg>
</template>

<script>
import { AggregateChartColors } from '@/store/types';

export default {
  props: {
    size: {
      type: Number,
      default: 16,
    },
    backgroundColor: {
      type: String,
      default: 'white',
    },
    fillColor: {
      type: String,
      default: AggregateChartColors.NO_DATA,
    },
    strokeWidth: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    center() {
      return {
        cx: this.size / 2,
        cy: this.size / 2,
      };
    },
  },
};
</script>

<style scoped>
.status-dot {
  filter: drop-shadow(0px 0px 12px rgba(27, 7, 83, 0.25));
}
</style>
